<template>
  <div>
    <el-upload
        ref='upload'
        :class="{hide:hideUpload}"
        :disabled='imgDisabled'
        action=""
        accept="image/jpeg,image/gif,image/png,image/bmp"
        list-type="picture-card"
        :file-list="fileList"
        :http-request="handleRequest"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :on-preview="handlePictureCardPreview">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img
            class="el-upload-list__item-thumbnail"
            :src="file.url" alt=""
        >
        <span class="el-upload-list__item-actions">
          <span
              title="设置产品头像"
              class="el-upload-list__item-delete"
              @click="handleProduct(file)">
          <i class="el-icon-top"></i>
        </span>
        <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
      </div>
    </el-upload>
    <el-dialog
        width="30%"
        title="图片详情"
        :visible.sync="dialogVisible"
        append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'upload',
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: false,
      hideUpload: false,
      loser: true
    }
  },
  props: {
    limitCount: {
      type: Number,
      default: 1
    },
    imgDisabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: null
    },
    DeviceTypeId: '',
  },
  created() {
    this.hideUpload = this.fileList.length >= this.limitCount
  },
  watch: {
    'fileList': function (fileList) {
      this.hideUpload = this.fileList.length >= this.limitCount
    }
  },
  methods: {
    handleRequest(param) {
      let fileObj = param.file;
      let form = new FormData();
      // // 文件对象
      form.append('objFile', fileObj);
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };
      this.axios.post('/api/File/PostDeviceTypeImages?DeviceTypeId=' + this.DeviceTypeId, form, config).then((res) => {
        this.$emit('addPath', res)
      }).catch(e => {
        this.$emit('addPath', res)
      })
    },
    handleProduct(file) { // 设置产品头像
      this.axios.put('/api/File?DeviceTypeId=' + this.DeviceTypeId+'&imageId='+file.name).then((res) => {
        this.$notify({
          title: '成功',
          message: '操作成功',
          type: 'success'
        });
      })
    },
    beforeAvatarUpload(file, fileList) {
      this.loser = true
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 512 / 512 < 2
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        this.loser = false
        return false
      } else if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!')
        this.loser = false
        return false
      } else {
        return isJPG && isLt2M
      }
    },
    handleRemove(file, fileList) { // 删除图片
      let data = []
      data.push(file.name)
      this.axios.put('/api/File/RemoveDeviceTypeImages?DeviceTypeId=' + this.DeviceTypeId, data).then((res) => {
        this.$emit('delImgPath', file.name)
      }).catch(e => {
        this.$emit('delImgPath', file.name)
      })
      this.hideUpload = this.fileList >= this.limitCount
    },
    handlePictureCardPreview(file) { // 放大
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  }
}
</script>
<style>
.el-notification__group {
  margin-right: auto;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>>
